import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Label, Alert, Button, Form, Table, ButtonGroup, UncontrolledTooltip } from "reactstrap";
import Page from "components/Page";
import { Textbox, Select } from "react-inputs-validation";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import ValoresCotizacionHogar from "./ValoresCotizacionHogar";
import { FetchCalculoPrimaHogar, FetchListarCarritoHogar, setProductoActualCotizadoHogar, FetchGenerarEnviarPdfHogar, FetchTotalesCabeceraCotizadores, FetchDataCoberturasHogarAdvance } from "../../redux/actions/ACarritoProductos";
import { recuperarDatosFacturacionFetch } from "../../redux/actions/aCotizacion";
import { SelectButton } from "primereact/selectbutton";
import Planes from '../Generales/Planes';
import { obtenerDatosHogar } from '../../utils/validaciones';



const arrayRiesgos = [
  { id: 2, name: "Primer Riesgo Relativo" },
  { id: 1, name: "Primer Riesgo Absoluto" }
];

const arrayDescuentos = [
  { id: 0, name: "0%" },
  { id: 1, name: "1%" },
  { id: 2, name: "2%" },
  { id: 3, name: "3%" },
  { id: 4, name: "4%" },
  { id: 5, name: "5%" },
  { id: 6, name: "6%" },
  { id: 7, name: "7%" },
  { id: 8, name: "8%" },
  { id: 9, name: "9%" },
  { id: 10, name: "10%" },
  { id: 11, name: "11%" },
  { id: 12, name: "12%" },
  { id: 13, name: "13%" },
  { id: 14, name: "14%" },
  { id: 15, name: "15%" },
  { id: 16, name: "16%" },
  { id: 17, name: "17%" },
  { id: 18, name: "18%" },
  { id: 19, name: "19%" },
  { id: 20, name: "20%" },
]

class CotizacionValoresPaso4HogarAig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      formEditado: false,
      arrayDeducibles: this.props.catalogosHogar.setRelatividadesHogar.deductibles ? this.props.catalogosHogar.setRelatividadesHogar.deductibles : [],
      deducibleSelected: this.props.catalogosHogar.setRelatividadesHogar.valorDefectoDeducible ? this.props.catalogosHogar.setRelatividadesHogar.valorDefectoDeducible : "",
      catAndNonCat: true,
      descuentoIncendio: 0,
      descuentoRobo: 0,
      riesgoSelected: 1,
      datosHogar: obtenerDatosHogar(null),
      //Seccion de incendios
      seccionIncendios: undefined,
      arrayValoresSeccionIncendios: undefined,
      arrayErroresIncendio: undefined,
      //Seccion de Robo
      seccionRobo: undefined,
      arrayValoresSeccionRobo: undefined,
      arrayErroresRobo: undefined,
      cargarTotalesRecuperado: false,
      habilitarBotonContinuar: this.props.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima === "" ? false : true,
      //Seccion Amparos Basico de Daños
      seccionAmparosBasicosDanios: undefined,
      arrayValoresAmparosBasicosDanios: undefined,
      mostrarAmparosBasicosDanios: false,
      // Seccion de Amparos Derivados de Siniestros        
      seccionAmparosBasicosDerivadoSiniestros: undefined,
      arrayValoresAmparosBasicosDerivadoSiniestros: undefined,
      mostrarAmparosBasicosDerivadoSiniestros: false,
      // Seccion de Amparos Opcionales       
      seccionAmparosOpcionales: undefined,
      seccionAmparosDaniosPerdidas: undefined,
      seccionAmparosDerivadoSiniestros: undefined,
      arrayValoresAmparosOpcionales: undefined,
      arrayValoresAmparosDaniosPerdidas: undefined,
      arrayValoresAmparosDerivadoSiniestros: undefined,
      arrayErroresAmparosOpcionales: undefined,
      arrayErroresAmparosDaniosPerdidas: undefined,
      arrayErroresAmparosDerivadoSiniestros: undefined,
      verNumeroPersonasAP: undefined,
      NumeroPersonasvalidador: undefined,
      planContenidosSeleccionado: null,
      planEstructuraSeleccionado: null,
      valoresCobertura: [],
      sumaIncendio: 0,
      errorSumaIncendio: false

    };
  }

  onRegresar = async () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const codEdicion = queryParams.get('codEdicion');
    const cod = queryParams.get('cod');
    if (codEdicion === undefined || codEdicion === '' || codEdicion === null) {
      if (this.state.datosHogar.codigo === 'hogar-aig') {
        this.props.history.push({
          pathname: "/cotizacion-hogar-paso2",
          search: this.state.datosHogar.codigo != null
            ? "?producto=" + this.state.datosHogar.codigo
            : "",
        });
        return null;
      }
      this.props.history.push({
        pathname: this.state.datosHogar.producto == 'HOGAR AIG' ? "/cotizacion-hogar-paso2" : '/cotizacion-hogar-paso3',
        search: `?back=true`
      });
    }
    else {
      if (this.state.datosHogar.codigo === 'hogar-aig') {
        this.props.history.push({
          pathname: "/cotizacion-hogar-paso2",
          search: `codEdicion=${codEdicion}${this.state.datosHogar.codigo != null ? "&producto=" + this.state.datosHogar.codigo : ""}`, //agregar parametros de la url,
        });
        return null;
      }
      this.props.history.push({
        pathname: this.state.datosHogar.producto == 'HOGAR AIG' ? "/cotizacion-hogar-paso2" : '/cotizacion-hogar-paso3',
        search: `codEdicion=${codEdicion}`, //agregar parametros de la url,
      });
    }
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }

  onValidateform = async () => {
    let { formEditado, arrayValoresSeccionIncendios, seccionIncendios, arrayErroresIncendio, arrayErroresRobo, arrayValoresSeccionRobo, seccionRobo, seccionAmparosBasicosDanios, deducibleSelected, arrayDeducibles, riesgoSelected, seccionAmparosBasicosDerivadoSiniestros, mostrarAmparosBasicosDerivadoSiniestros, mostrarAmparosBasicosDanios, seccionAmparosOpcionales, seccionAmparosDaniosPerdidas, seccionAmparosDerivadoSiniestros, arrayValoresAmparosOpcionales, arrayValoresAmparosDaniosPerdidas, arrayValoresAmparosDerivadoSiniestros, verNumeroPersonasAP, NumeroPersonasvalidador } = this.state;

    console.log("formEditado", formEditado)

    if (formEditado === true) {

      if (this.state.datosHogar.codigo == 'advance') {

        const datosEnviar = {
          empresa: "AIGMETROPOLITANA",
          idCarrito: this.props.carrito.mongoCarrito,
          planEstructura: this.state.planEstructuraSeleccionado,
          planContenidos: this.state.planContenidosSeleccionado

        }



        await this.props.caluloPrima(datosEnviar);

        let datosCarritoHogar =
        {
          "empresa": "AIGMETROPOLITANA",
          "idCarrito": this.props.carrito.mongoCarrito
        }
        await this.props.listarCarritoHogar(datosCarritoHogar);
        // actualizar los datos del cotizadores                          


        let datosJSON = {
          empresa: "AIGMETROPOLITANA",
          plataforma: "WEB",
          idCarrito: this.props.carrito.mongoCarrito
        }

        await this.props.datosFacturacion(datosJSON);
        if (this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "") {
          let param = {
            pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
            totalItems: this.props.dataFacturacion.numItemsCarrito ? this.props.dataFacturacion.numItemsCarrito : "0",
            totalPrima: (this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal) ? this.props.dataFacturacion.carValoresTotales.primaTotal : "0.00",
            ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
          }
          await this.props.actualizarTotalesCabecera(param);
        }







        this.setState({
          formEditado: false
        })

      } else {
        let HasError = false;
        this.toggleValidating(true);
        //validar que los valores del array de cada seccion se encuentre lleno
        arrayValoresSeccionIncendios.forEach((element, i) => {
          if (element.cobValorIngresado < 0 || element.cobValorIngresado === "" || element.cobValorIngresado === null) {
            HasError = true;
          }
        });
        arrayValoresSeccionRobo.forEach((element, i) => {
          if (element.cobValorIngresado < 0 || element.cobValorIngresado === "" || element.cobValorIngresado === null) {
            HasError = true;
          }
        });
        if (deducibleSelected === "") {
          HasError = true;
        }
        if (verNumeroPersonasAP && verNumeroPersonasAP === true) {
          if (!NumeroPersonasvalidador || NumeroPersonasvalidador === undefined || NumeroPersonasvalidador === "" || NumeroPersonasvalidador <= 0) {
            HasError = true;
          }
        }
        if (!HasError) {
          arrayValoresAmparosOpcionales.forEach(amparo => {
            if (amparo.cobCodigo === "llaveProtegida" || amparo.cobCodigo === "documentosProtegidos") {
              if (amparo.cobValorIngresado === "0.00" && !amparo.cobValorCambio) {
                amparo.cobValorIngresado = "";
              }
            }
          });
          //Crear objeto para los deducibles      
          let ObjDeducible = arrayDeducibles.filter((item) =>
            item.id === deducibleSelected.toString()
          )
          ObjDeducible = ObjDeducible[0];
          //Preparar los campos ingresados Seccion Incendios     
          seccionIncendios.secCoberturas = arrayValoresSeccionIncendios;
          seccionRobo.secCoberturas = arrayValoresSeccionRobo;
          seccionAmparosOpcionales.secCoberturas = arrayValoresAmparosOpcionales;
          seccionAmparosDaniosPerdidas.secCoberturas = arrayValoresAmparosDaniosPerdidas
          seccionAmparosDerivadoSiniestros.secCoberturas = arrayValoresAmparosDerivadoSiniestros

          let arraySecciones = [];
          arraySecciones.push(seccionIncendios);
          arraySecciones.push(seccionRobo);
          arraySecciones.push(seccionAmparosOpcionales);
          arraySecciones.push(seccionAmparosDaniosPerdidas)
          arraySecciones.push(seccionAmparosDerivadoSiniestros)

          //Validar que no sea una edicion de ubicacion
          const queryParams = new URLSearchParams(this.props.location.search);
          const codEdicion = queryParams.get('codEdicion');
          let cod = this.props.carrito.carCodigoProductoActual
          if (codEdicion !== undefined && codEdicion !== "" && codEdicion !== null) {
            cod = codEdicion
          }

          var secciones = arraySecciones

          if (this.state.datosHogar.codigo != 'hogar-aig') {
            secciones = secciones.filter(sec => sec.secCodigo != 'amparosDaniosPerdidas')
            secciones = secciones.filter(sec => sec.secCodigo != "amparosDerivadoSiniestros")
          }
          //armar el objeto para enviar información al servicio      
          let datosEnviar = {
            empresa: "AIGMETROPOLITANA",
            idCarrito: this.props.carrito.mongoCarrito,
            planEstructura: null,
            planContenidos: null,
            secciones: secciones,
            codigo: cod,
            amparosDaniosPerdidas: seccionAmparosBasicosDanios,
            amparosDerivadosSiniestros: seccionAmparosBasicosDerivadoSiniestros,
            deductibles: ObjDeducible,
            tipoValorRobo: riesgoSelected,
          }



          if (this.state.datosHogar.codigo == 'hogar-aig') {
            datosEnviar.catAndNonCat = this.state.catAndNonCat
            datosEnviar.descuentoIncendio = this.state.descuentoIncendio
            datosEnviar.descuentoRobo = this.state.descuentoRobo
          }
          console.log(JSON.stringify(datosEnviar))
          console.log('arrayValoresAmparosDerivadoSiniestros', datosEnviar)
          await this.props.caluloPrima(datosEnviar);
          //Verificar si la respuesta es correcta o incorrecta
          if (this.props.datosCarritoHogar.setCalculoPrimaHogarErrores !== undefined && this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.transaccion == false) {
            if (this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.seccionesResultado) {
              // Obtener el array de errores de carrito Incendio

              //actualizar los totales
              let param = { pathIcono: "", totalItems: "0", totalPrima: "0.00", ramoCotizador: "" }
              await this.props.actualizarTotalesCabecera(param);
            }
          }

          if (this.props.datosCarritoHogar.setCalculoPrimaHogar !== undefined && this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado !== undefined) {
            if (this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado) {
              // buscar el array de respuesta por codigo incendio
              let PrimasCalculadasIcendio = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "incendio"
              )
              PrimasCalculadasIcendio = PrimasCalculadasIcendio[0];
              // buscar el array de respuesta por codigo robo
              let PrimasCalculadasRobo = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "robo"
              )
              PrimasCalculadasRobo = PrimasCalculadasRobo[0];
              // buscar el array de respuesta por codigo los Amparos de Daños
              let CalculosAmparosDaniosPerdidas = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "amparosDaniosPerdidas"
              )
              CalculosAmparosDaniosPerdidas = CalculosAmparosDaniosPerdidas[0];
              if (CalculosAmparosDaniosPerdidas && CalculosAmparosDaniosPerdidas.secCoberturasResultado) {
                CalculosAmparosDaniosPerdidas.secCoberturas = CalculosAmparosDaniosPerdidas.secCoberturasResultado;
                //Visualizar seccion
                this.setState({ mostrarAmparosBasicosDanios: CalculosAmparosDaniosPerdidas.secMostrarSeccion ? CalculosAmparosDaniosPerdidas.secMostrarSeccion : false })
              }
              // buscar el array de respuesta por codigo los Amparos de gastos adicionales derivados desiniestro
              let CalculosAmparosDerivadoSiniestros = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "amparosDerivadoSiniestros"
              )
              CalculosAmparosDerivadoSiniestros = CalculosAmparosDerivadoSiniestros[0];
              if (CalculosAmparosDaniosPerdidas && CalculosAmparosDaniosPerdidas.secCoberturasResultado) {
                CalculosAmparosDerivadoSiniestros.secCoberturas = CalculosAmparosDerivadoSiniestros.secCoberturasResultado;
                //Visualizar seccion
                this.setState({ mostrarAmparosBasicosDerivadoSiniestros: CalculosAmparosDaniosPerdidas.secMostrarSeccion ? CalculosAmparosDaniosPerdidas.secMostrarSeccion : false })
              }

              // buscar el array de respuesta por codigo amparosOpcionales
              let PrimasCalculadasAmparosOpcionales = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "amparosOpcionales"
              )
              PrimasCalculadasAmparosOpcionales = PrimasCalculadasAmparosOpcionales[0];

              console.log('PrimasCalculadasAmparosOpcionalesqwdqwd', PrimasCalculadasAmparosOpcionales)



              let PrimasCalculadasAmparosDaniosPerdidas = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "amparosDaniosPerdidas"
              )
              PrimasCalculadasAmparosDaniosPerdidas = PrimasCalculadasAmparosDaniosPerdidas[0];





              let PrimasCalculadasAmparosDerivadoSiniestros = this.props.datosCarritoHogar.setCalculoPrimaHogar.seccionesResultado.filter((item) =>
                item.secCodigo === "amparosDerivadoSiniestros"
              )
              PrimasCalculadasAmparosDerivadoSiniestros = PrimasCalculadasAmparosDerivadoSiniestros[0];

              this.setState({
                arrayValoresSeccionIncendios: PrimasCalculadasIcendio.secCoberturasResultado,
                arrayErroresIncendio: undefined,
                arrayValoresSeccionRobo: PrimasCalculadasRobo.secCoberturasResultado,
                arrayErroresRobo: undefined,
                seccionAmparosBasicosDanios: CalculosAmparosDaniosPerdidas,
                arrayValoresAmparosBasicosDanios: CalculosAmparosDaniosPerdidas ? CalculosAmparosDaniosPerdidas.secCoberturas : undefined,
                seccionAmparosBasicosDerivadoSiniestros: CalculosAmparosDerivadoSiniestros,
                arrayValoresAmparosBasicosDerivadoSiniestros: CalculosAmparosDerivadoSiniestros ? CalculosAmparosDerivadoSiniestros.secCoberturas : undefined,
                arrayValoresAmparosOpcionales: PrimasCalculadasAmparosOpcionales.secCoberturasResultado,
                arrayValoresAmparosDaniosPerdidas: PrimasCalculadasAmparosDaniosPerdidas.secCoberturasResultado,
                arrayValoresAmparosDerivadoSiniestros: PrimasCalculadasAmparosDerivadoSiniestros.secCoberturasResultado,
                arrayErroresAmparosOpcionales: undefined,
                validate: false,
                cargarTotalesRecuperado: false
              })
              //Listar todo el carrito cuando se efectuaron correctamente los cálculos
              let datosCarritoHogar =
              {
                "empresa": "AIGMETROPOLITANA",
                "idCarrito": this.props.carrito.mongoCarrito
              }
              await this.props.listarCarritoHogar(datosCarritoHogar);
              // actualizar los datos del cotizadores                          
              let datosJSON = {
                empresa: "AIGMETROPOLITANA",
                plataforma: "WEB",
                idCarrito: this.props.carrito.mongoCarrito
              }
              await this.props.datosFacturacion(datosJSON);
              if (this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "") {
                let param = {
                  pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
                  totalItems: this.props.dataFacturacion.numItemsCarrito ? this.props.dataFacturacion.numItemsCarrito : "0",
                  totalPrima: (this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal) ? this.props.dataFacturacion.carValoresTotales.primaTotal : "0.00",
                  ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
                }
                await this.props.actualizarTotalesCabecera(param);
              }

            }
          }
          this.setState({ formEditado: false })
        }

      }

    }
    else {
      //armar el objeto para enviar información al servicio      
      const datosEnviar = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        idCarrito: this.props.carrito.mongoCarrito,
        accion: "generar"

      }
      //console.log("DatosGenerarPdf",JSON.stringify(datosEnviar))   
      await this.props.guardarGenerarPdfCotizacion(datosEnviar);



      if (this.props.datosCarritoHogar.setGenerarPdfCotizacionHogar !== undefined && this.props.datosCarritoHogar.setGenerarPdfCotizacionHogar.transaccion === true) {
        this.props.history.push({
          pathname: "/cotizacion-hogar-paso5",
          search: `?idCarrito=${this.props.carrito.mongoCarrito}`

        });
      }

    }

  }

  componentDidUpdate(prevProps, prevState) {
    console.log(
      "componentDidUpdate",
    )
    if (this.props.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima !== prevProps.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima) {
      // Validar si la prima es valor al valor parametrizable y permitir continuar o bloquear el flujo
      if (this.props.datosCarritoHogar && this.props.datosCarritoHogar.setCarritoHogar && this.props.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima === "") {
        this.setState({ habilitarBotonContinuar: false });
      }
      else {
        this.setState({ habilitarBotonContinuar: true });
      }
      //Fin Validar si la prima es valor al valor parametrizable y permitir continuar o bloquear el flujo
    }
    if (this.props.datosCarritoHogar.calculoPrimaHogarError !== prevProps.datosCarritoHogar.calculoPrimaHogarError) {
      this.setState({ habilitarBotonContinuar: this.props.datosCarritoHogar.calculoPrimaHogarError });
    }



    if (this.props.datosCarritoHogar.setCalculoPrimaHogarErrores !== prevProps.datosCarritoHogar.setCalculoPrimaHogarErrores) {

      let ObtenerErroresIncendio = this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.arrayErroresIncendio



      let ObtenerErroresRobo = this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.arrayErroresRobo


      let erroresAmparosOpcionales = []

      if (this.props.datosCarritoHogar &&
        this.props.datosCarritoHogar.setCalculoPrimaHogarErrores &&
        this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.arrayErroresAmparosOpcionales &&
        this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.arrayErroresAmparosOpcionales[0]

      ) {
        erroresAmparosOpcionales = this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.arrayErroresAmparosOpcionales
      }

      // Obtener el array de errores Amparos Opcionales



      let arrayErroresSeccion_amparosDaniosPerdidas = this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.arrayErroresAmparosDaniosPerdidas;




      let ObtenerErroresAmparosDerivadoSiniestros = this.props.datosCarritoHogar.setCalculoPrimaHogarErrores.arrayErroresAmparosDerivadoSiniestros

      this.setState({
        arrayErroresIncendio: ObtenerErroresIncendio,
        arrayErroresRobo: ObtenerErroresRobo,
        arrayErroresAmparosOpcionales: erroresAmparosOpcionales,
        arrayErroresAmparosDaniosPerdidas: arrayErroresSeccion_amparosDaniosPerdidas,
        arrayErroresAmparosDerivadoSiniestros: ObtenerErroresAmparosDerivadoSiniestros,
        cargarTotalesRecuperado: false
      })
    }
  }

  async componentDidMount() {

    await this.props.cargarCoberturasHogarAdvance();

    this.obtenerValores()

    console.log('productosHogar: ', this.props.datosCarritoHogar)
    window.scrollTo(0, 0)
    //Validar que la cotizacion sea nueva o es recuperacion
    const queryParams = new URLSearchParams(this.props.location.search);
    const recuperar = queryParams.get('recuperar');

    let producto = null
    let seguro = this.props.carrito.carDescripcionSeguro;

    switch (seguro) {
      case 'HOGAR AIG':
        producto = 'hogar-aig'
        break;

      case 'HOGAR ADVANCE':
        producto = 'advance'
        break;

      default:
            producto = 'hogar-aig'
        break;
    }

    this.setState({ datosHogar: obtenerDatosHogar(producto) })

    //Validar que se este recuperando la cotizacion    
    if (recuperar && recuperar !== null && recuperar !== "" && recuperar !== undefined && (recuperar === true || recuperar === "true")) {
      this.precargarSeccionesCotizacionRecuperada();
      this.precargarPlanes()
    }
    else {
      this.precargarSeccionesCotizacionNueva();
    }

  }


  obtenerValores() {

    var auxPrincipal = [];

    this.props.datosCarritoHogar.setPlanesHogarAdvance.planesContenido[0].valoresCobertura.forEach(cobertura => {
      var auxSecundario = []

      this.props.datosCarritoHogar.setPlanesHogarAdvance.planesContenido.forEach(plan => {

        plan.valoresCobertura.forEach(valor => {

          if (cobertura.titulo == valor.titulo) {
            auxSecundario.push(valor)

          }

        });

      });
      auxPrincipal.push(auxSecundario)

    })
    this.setState({
      valoresCobertura: auxPrincipal
    })

    console.log('obtenerValores', auxPrincipal)





  }



  async precargarPlanes() {

    if (this.props.datosCarritoHogar.setCarritoHogar.carProductos[0] && this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planContenidos && this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planContenidos.primaCobertura) {
      this.setState({
        planContenidosSeleccionado: this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planContenidos.codigoProducto,
        formEditado: true,
      })
    }

    if (this.props.datosCarritoHogar.setCarritoHogar.carProductos[0] && this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planEstructura && this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planEstructura.primaCobertura) {
      this.setState({
        planEstructuraSeleccionado: this.props.datosCarritoHogar.setCarritoHogar.carProductos[0].planEstructura.codigoProducto,
        formEditado: true
      })
    }
  }


  async precargarSeccionesCotizacionRecuperada() {
    //Obtener el ultimo producto que se estuvo cotizando
    let codigoProductoActual = this.props.datosCarritoHogar.setCarritoHogar.carCodigoProductoActual;
    //Verificar si es una edicion
    const queryParams = new URLSearchParams(this.props.location.search);
    const codigoProdActual = queryParams.get('cod');
    const codEdicion = queryParams.get('codEdicion');
    if (codigoProdActual && codigoProdActual !== undefined && codigoProdActual !== '') {
      codigoProductoActual = codigoProdActual;
    }
    else if (codEdicion && codEdicion !== undefined && codEdicion !== '') {
      codigoProductoActual = codEdicion;
    }

    //validar si existen actualizaciones de datos para el scoring
    if (this.props.datosCarritoHogar.setCarritoHogar && this.props.datosCarritoHogar.setCarritoHogar.leadUltimosPasosPorItem && this.props.datosCarritoHogar.setCarritoHogar.leadUltimosPasosPorItem !== undefined && this.props.datosCarritoHogar.setCarritoHogar.leadUltimosPasosPorItem !== "") {
      let ObtenerItemPasos = this.props.datosCarritoHogar.setCarritoHogar.leadUltimosPasosPorItem.filter((item) =>
        item.codigo === codigoProductoActual
      )
      ObtenerItemPasos = ObtenerItemPasos[0];
      if (ObtenerItemPasos.banderaEdicion && ObtenerItemPasos.banderaEdicion === 'true') {
        //Estilo al boton actualizar
        this.setState({ formEditado: true });
      }
    }

    // Buscar el producto en el carrito
    let ObtenerProductoActual = this.props.datosCarritoHogar.setCarritoHogar.carProductos.filter((item) =>
      item.codigo === codigoProductoActual
    )
    ObtenerProductoActual = ObtenerProductoActual[0];
    //Setear Producto actual
    await this.props.setProductoActual(ObtenerProductoActual);

    if (ObtenerProductoActual && this.state.datosHogar.codigo == 'hogar-aig') {
      this.setState({
        catAndNonCat: ObtenerProductoActual.calculosCatAndNonCat,
        descuentoIncendio: ObtenerProductoActual.descuentoIncendio,
        descuentoRobo: ObtenerProductoActual.descuentoRobo
      })

    }
    if (ObtenerProductoActual.coberturas) {
      //Obtener Secciones Coberturas Incendio
      let ObtenerSeccionIcendio = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "incendio"
      )
      ObtenerSeccionIcendio = ObtenerSeccionIcendio[0];
      //Obtener Secciones Coberturas Robo
      let ObtenerSeccionRobo = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "robo"
      )
      ObtenerSeccionRobo = ObtenerSeccionRobo[0];
      //Precargar las secciones y coberturas del servicio para las secciones      
      let ObtenerSeccionIcendioCatalogo = this.props.seccionesCoberturasHogar.filter((item) =>
        item.secCodigo === "incendio"
      )
      ObtenerSeccionIcendioCatalogo = ObtenerSeccionIcendioCatalogo[0];

      let ObtenerSeccionRoboCatalogo = this.props.seccionesCoberturasHogar.filter((item) =>
        item.secCodigo === "robo"
      )
      ObtenerSeccionRoboCatalogo = ObtenerSeccionRoboCatalogo[0];
      //Validar que en la recuperacion el array de valores de las secciones tenga valores
      let arrayValoresIncendio = undefined;
      if (ObtenerSeccionIcendio && ObtenerSeccionIcendio.secCoberturasResultado === undefined || ObtenerSeccionIcendio.secCoberturasResultado === null) {
        //Obtener Secciones Coberturas Incendio
        let ObjIcendio = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "incendio"
        )
        ObjIcendio = ObjIcendio[0];
        //Construir array de secciones con valores defecto Incendio
        ObjIcendio.secCoberturas.forEach((element, i) => {
          ObjIcendio.secCoberturas[i] = { ...ObjIcendio.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
        });
        arrayValoresIncendio = ObjIcendio.secCoberturas;
      }
      else {
        arrayValoresIncendio = ObtenerSeccionIcendio.secCoberturasResultado;
      }
      let arrayValoresRobo = undefined;
      if (!ObtenerSeccionRobo) {
        //Obtener Secciones Coberturas Incendio
        let Obj = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "incendio"
        )
        Obj = Obj[0];
        //Construir array de secciones con valores defecto Incendio
        Obj.secCoberturas.forEach((element, i) => {
          Obj.secCoberturas[i] = { ...Obj.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
        });
        arrayValoresRobo = Obj.secCoberturas;
      }
      else {
        arrayValoresRobo = ObtenerSeccionRobo.secCoberturasResultado;
      }
      //Obtener las secciones de Amparos Básico de Daños
      let ObtenerSeccionAmparosBasicosDaniosAux = undefined;
      let ObtenerSeccionAmparoBasicoDanios = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "amparosDaniosPerdidas"
      )
      ObtenerSeccionAmparoBasicoDanios = ObtenerSeccionAmparoBasicoDanios[0];
      if (ObtenerSeccionAmparoBasicoDanios) {
        ObtenerSeccionAmparosBasicosDaniosAux = ObtenerSeccionAmparoBasicoDanios.secCoberturasResultado;
        if (!ObtenerSeccionAmparoBasicoDanios.secCoberturas) {
          ObtenerSeccionAmparoBasicoDanios.secCoberturas = ObtenerSeccionAmparoBasicoDanios.secCoberturasResultado;
        }
      }
      else {
        //Obtener Seccion Amparos Basicos de Daños
        ObtenerSeccionAmparosBasicosDaniosAux = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "amparosDaniosPerdidas"
        )
        ObtenerSeccionAmparosBasicosDaniosAux = ObtenerSeccionAmparosBasicosDaniosAux[0];
      }
      //Obtener las secciones de Amparos de Gasto Derivados Siniestro
      let ObtenerSeccionAmparosDerivadoSiniestroAux = undefined;
      let ObtenerSeccionAmparoDerivadoSiniestros = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "amparosDerivadoSiniestros"
      )
      ObtenerSeccionAmparoDerivadoSiniestros = ObtenerSeccionAmparoDerivadoSiniestros[0];
      if (ObtenerSeccionAmparoDerivadoSiniestros) {
        ObtenerSeccionAmparosDerivadoSiniestroAux = ObtenerSeccionAmparoDerivadoSiniestros.secCoberturasResultado;
        if (!ObtenerSeccionAmparoDerivadoSiniestros.secCoberturas) {
          ObtenerSeccionAmparoDerivadoSiniestros.secCoberturas = ObtenerSeccionAmparoDerivadoSiniestros.secCoberturasResultado;
        }
      }
      else {
        //Obtener Seccion Amparos Basicos de Daños
        ObtenerSeccionAmparosDerivadoSiniestroAux = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "amparosDerivadoSiniestros"
        )
        ObtenerSeccionAmparosDerivadoSiniestroAux = ObtenerSeccionAmparosDerivadoSiniestroAux[0];
      }


      //Obtener Secciones Coberturas de Amparos Opcionales
      let ObtenerSeccionAmparosOpcionales = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "amparosOpcionales"
      )
      ObtenerSeccionAmparosOpcionales = ObtenerSeccionAmparosOpcionales[0];

      //Obtener Secciones Coberturas de Amparos Opcionales
      let ObtenerSeccionAmparosDaniosPerdidas = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "amparosDaniosPerdidas"
      )
      ObtenerSeccionAmparosDaniosPerdidas = ObtenerSeccionAmparosDaniosPerdidas[0];

      //Obtener Secciones Coberturas de Amparos Opcionales
      let ObtenerSeccionAmparosDerivadoSiniestros = ObtenerProductoActual.coberturas.filter((item) =>
        item.secCodigo === "amparosDerivadoSiniestros"
      )
      ObtenerSeccionAmparosDerivadoSiniestros = ObtenerSeccionAmparosDerivadoSiniestros[0];



      //Precargar las secciones y coberturas de Amparos Opcionales del Catalogo
      let ObtenerSeccionAmparosOpcionalesCatalogo = this.props.seccionesCoberturasHogar.filter((item) =>
        item.secCodigo === "amparosOpcionales"
      )
      ObtenerSeccionAmparosOpcionalesCatalogo = ObtenerSeccionAmparosOpcionalesCatalogo[0];



      //Precargar las secciones y coberturas de Amparos Opcionales del Catalogo
      let ObtenerSeccionAmparosDaniosPerdidasCatalogo = this.props.seccionesCoberturasHogar.filter((item) =>
        item.secCodigo === "amparosDaniosPerdidas"
      )
      ObtenerSeccionAmparosDaniosPerdidasCatalogo = ObtenerSeccionAmparosDaniosPerdidasCatalogo[0];


      //Precargar las secciones y coberturas de Amparos Opcionales del Catalogo
      let ObtenerSeccionAmparosDerivadoSiniestrosCatalogo = this.props.seccionesCoberturasHogar.filter((item) =>
        item.secCodigo === "amparosDerivadoSiniestros"
      )
      ObtenerSeccionAmparosDerivadoSiniestrosCatalogo = ObtenerSeccionAmparosDerivadoSiniestrosCatalogo[0];

      //Validar que en la recuperacion el array de valores de las seccion Amparos Opcionales tenga valores
      let arrayValoresAmparosOpcionales = undefined;
      if (ObtenerSeccionAmparosOpcionales && ObtenerSeccionAmparosOpcionales.secCoberturasResultado === undefined || ObtenerSeccionAmparosOpcionales.secCoberturasResultado === null) {
        //Obtener Secciones Coberturas Amparos Opcionares
        let ObjAmpOpcionales = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "amparosOpcionales"
        )
        ObjAmpOpcionales = ObjAmpOpcionales[0];
        //Construir array de secciones con valores Amparos Opcionares
        ObjAmpOpcionales.secCoberturas.forEach((element, i) => {
          if (element.cobCodigo === "personalDomestico") {
            ObjAmpOpcionales.secCoberturas[i] = { ...ObjAmpOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00", cobNumeroPersonas: 0 }
          }
          else {
            ObjAmpOpcionales.secCoberturas[i] = { ...ObjAmpOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
          }
        });
        arrayValoresAmparosOpcionales = ObjAmpOpcionales.secCoberturas;
      }
      else {
        arrayValoresAmparosOpcionales = ObtenerSeccionAmparosOpcionales.secCoberturasResultado;
      }
      //Validar si es que ha sido ingresado un valor en AP de personas para mostrar la seccion
      arrayValoresAmparosOpcionales.forEach((element, i) => {
        if (element.cobCodigo === "personalDomestico" && parseFloat(element.cobValorIngresado) > 0 && element.cobNumeroPersonas && parseInt(element.cobNumeroPersonas) > 0) {
          this.setState({
            verNumeroPersonasAP: true,
            NumeroPersonasvalidador: element.cobValorIngresado
          })
        }
      });




      //Validar que en la recuperacion el array de valores de las seccion Amparos Opcionales tenga valores
      let arrayValoresAmparosDaniosPerdidas = undefined;
      if (ObtenerSeccionAmparosDaniosPerdidas && ObtenerSeccionAmparosDaniosPerdidas.secCoberturasResultado === undefined || ObtenerSeccionAmparosDaniosPerdidas.secCoberturasResultado === null) {
        //Obtener Secciones Coberturas Amparos Opcionares
        let ObjAmpOpcionales = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "amparosDaniosPerdidas"
        )
        ObjAmpOpcionales = ObjAmpOpcionales[0];
        //Construir array de secciones con valores Amparos Opcionares
        ObjAmpOpcionales.secCoberturas.forEach((element, i) => {
          if (element.cobCodigo === "personalDomestico") {
            ObjAmpOpcionales.secCoberturas[i] = { ...ObjAmpOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00", cobNumeroPersonas: 0 }
          }
          else {
            ObjAmpOpcionales.secCoberturas[i] = { ...ObjAmpOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
          }
        });
        arrayValoresAmparosDaniosPerdidas = ObjAmpOpcionales.secCoberturas;
      }
      else {
        arrayValoresAmparosDaniosPerdidas = ObtenerSeccionAmparosDaniosPerdidas.secCoberturasResultado;
      }
      //Validar si es que ha sido ingresado un valor en AP de personas para mostrar la seccion
      arrayValoresAmparosDaniosPerdidas.forEach((element, i) => {
        if (element.cobCodigo === "personalDomestico" && parseFloat(element.cobValorIngresado) > 0 && element.cobNumeroPersonas && parseInt(element.cobNumeroPersonas) > 0) {
          this.setState({
            verNumeroPersonasAP: true,
            NumeroPersonasvalidador: element.cobValorIngresado
          })
        }
      });


      //Validar que en la recuperacion el array de valores de las seccion Amparos Opcionales tenga valores
      let arrayValoresAmparosDerivadoSiniestros = undefined;
      if (ObtenerSeccionAmparosDerivadoSiniestros && ObtenerSeccionAmparosDerivadoSiniestros.secCoberturasResultado === undefined || ObtenerSeccionAmparosDerivadoSiniestros.secCoberturasResultado === null) {
        //Obtener Secciones Coberturas Amparos Opcionares
        let ObjAmpOpcionales = this.props.seccionesCoberturasHogar.filter((item) =>
          item.secCodigo === "amparosOpcionales"
        )
        ObjAmpOpcionales = ObjAmpOpcionales[0];
        //Construir array de secciones con valores Amparos Opcionares
        ObjAmpOpcionales.secCoberturas.forEach((element, i) => {
          if (element.cobCodigo === "personalDomestico") {
            ObjAmpOpcionales.secCoberturas[i] = { ...ObjAmpOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00", cobNumeroPersonas: 0 }
          }
          else {
            ObjAmpOpcionales.secCoberturas[i] = { ...ObjAmpOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
          }
        });
        arrayValoresAmparosDerivadoSiniestros = ObjAmpOpcionales.secCoberturas;
      }
      else {
        arrayValoresAmparosDerivadoSiniestros = ObtenerSeccionAmparosDerivadoSiniestros.secCoberturasResultado;
      }
      //Validar si es que ha sido ingresado un valor en AP de personas para mostrar la seccion
      arrayValoresAmparosDerivadoSiniestros.forEach((element, i) => {
        if (element.cobCodigo === "personalDomestico" && parseFloat(element.cobValorIngresado) > 0 && element.cobNumeroPersonas && parseInt(element.cobNumeroPersonas) > 0) {
          this.setState({
            verNumeroPersonasAP: true,
            NumeroPersonasvalidador: element.cobValorIngresado
          })
        }
      });














      //Construir array de secciones con valores defecto Robo
      this.setState({
        arrayValoresSeccionIncendios: arrayValoresIncendio,
        arrayErroresIncendio: undefined,
        arrayValoresSeccionRobo: arrayValoresRobo,
        arrayErroresRobo: undefined,
        seccionIncendios: ObtenerSeccionIcendioCatalogo,
        seccionRobo: ObtenerSeccionRoboCatalogo,
        cargarTotalesRecuperado: true,
        seccionAmparosBasicosDanios: ObtenerSeccionAmparoBasicoDanios,
        arrayValoresAmparosBasicosDanios: ObtenerSeccionAmparosBasicosDaniosAux,
        deducibleSelected: parseInt(ObtenerProductoActual.deducibleSeleccionadoUsuario),
        riesgoSelected: parseInt(ObtenerProductoActual.tipoValorRobo),
        seccionAmparosBasicosDerivadoSiniestros: ObtenerSeccionAmparoDerivadoSiniestros,
        arrayValoresAmparosBasicosDerivadoSiniestros: ObtenerSeccionAmparosDerivadoSiniestroAux,
        mostrarAmparosBasicosDanios: ObtenerSeccionAmparoBasicoDanios.secMostrarSeccion ? ObtenerSeccionAmparoBasicoDanios.secMostrarSeccion : false,
        mostrarAmparosBasicosDerivadoSiniestros: ObtenerSeccionAmparoDerivadoSiniestros.secMostrarSeccion ? ObtenerSeccionAmparoDerivadoSiniestros.secMostrarSeccion : false,
        arrayValoresAmparosOpcionales: arrayValoresAmparosOpcionales,
        arrayValoresAmparosDaniosPerdidas: arrayValoresAmparosDaniosPerdidas,
        arrayValoresAmparosDerivadoSiniestros: arrayValoresAmparosDerivadoSiniestros,
        arrayErroresAmparosOpcionales: undefined,
        seccionAmparosOpcionales: ObtenerSeccionAmparosOpcionalesCatalogo,
        seccionAmparosDaniosPerdidas: ObtenerSeccionAmparosDaniosPerdidas,
        seccionAmparosDerivadoSiniestros: ObtenerSeccionAmparosDerivadoSiniestros

      })
    }
    else {
      this.precargarSeccionesCotizacionNueva()
    }
  }





  async precargarSeccionesCotizacionNueva() {
    //Obtener Secciones Coberturas Incendio
    let ObtenerSeccionIcendio = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "incendio"
    )
    ObtenerSeccionIcendio = ObtenerSeccionIcendio[0];
    //Construir array de secciones con valores defecto Incendio
    ObtenerSeccionIcendio.secCoberturas.forEach((element, i) => {
      ObtenerSeccionIcendio.secCoberturas[i] = { ...ObtenerSeccionIcendio.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
    });

    //Obtener Secciones Coberturas Robo
    let ObtenerSeccionRobo = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "robo"
    )
    ObtenerSeccionRobo = ObtenerSeccionRobo[0];
    //Construir array de secciones con valores defecto Robo
    ObtenerSeccionRobo.secCoberturas.forEach((element, i) => {
      ObtenerSeccionRobo.secCoberturas[i] = { ...ObtenerSeccionRobo.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
    });

    //Obtener Seccion Amparos Basicos de Daños
    let ObtenerSeccionAmparosBasicosDanios = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "amparosDaniosPerdidas"
    )
    ObtenerSeccionAmparosBasicosDanios = ObtenerSeccionAmparosBasicosDanios[0];

    //Obtener Seccion Amparos Derivados de Siniestros
    let ObtenerSeccionAmparosDerivadosSiniestros = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "amparosDerivadoSiniestros"
    )
    ObtenerSeccionAmparosDerivadosSiniestros = ObtenerSeccionAmparosDerivadosSiniestros[0];



    //Obtener Seccion Amparos Opcionales
    let ObtenerSeccionAmparosOpcionales = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "amparosOpcionales"
    )
    ObtenerSeccionAmparosOpcionales = ObtenerSeccionAmparosOpcionales[0];
    //Construir array de secciones con valores defecto amparos Opcionales
    ObtenerSeccionAmparosOpcionales.secCoberturas.forEach((element, i) => {
      if (element.cobCodigo === "personalDomestico") {
        ObtenerSeccionAmparosOpcionales.secCoberturas[i] = { ...ObtenerSeccionAmparosOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00", cobNumeroPersonas: 0 }
      }
      else {
        ObtenerSeccionAmparosOpcionales.secCoberturas[i] = { ...ObtenerSeccionAmparosOpcionales.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
      }
    });


    //Obtener Seccion Amparos Opcionales
    let ObtenerSeccionAmparosDaniosPerdidas = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "amparosDaniosPerdidas"
    )
    ObtenerSeccionAmparosDaniosPerdidas = ObtenerSeccionAmparosDaniosPerdidas[0];
    //Construir array de secciones con valores defecto amparos Opcionales
    ObtenerSeccionAmparosDaniosPerdidas.secCoberturas.forEach((element, i) => {
      if (element.cobCodigo === "personalDomestico") {
        ObtenerSeccionAmparosDaniosPerdidas.secCoberturas[i] = { ...ObtenerSeccionAmparosDaniosPerdidas.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00", cobNumeroPersonas: 0 }
      }
      else {
        ObtenerSeccionAmparosDaniosPerdidas.secCoberturas[i] = { ...ObtenerSeccionAmparosDaniosPerdidas.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
      }
    });


    //Obtener Seccion Amparos Opcionales
    let ObtenerSeccionAmparosDerivadoSiniestros = this.props.seccionesCoberturasHogar.filter((item) =>
      item.secCodigo === "amparosDerivadoSiniestros"
    )
    ObtenerSeccionAmparosDerivadoSiniestros = ObtenerSeccionAmparosDerivadoSiniestros[0];
    //Construir array de secciones con valores defecto amparos Opcionales
    ObtenerSeccionAmparosDerivadoSiniestros.secCoberturas.forEach((element, i) => {
      if (element.cobCodigo === "personalDomestico") {
        ObtenerSeccionAmparosDerivadoSiniestros.secCoberturas[i] = { ...ObtenerSeccionAmparosDerivadoSiniestros.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00", cobNumeroPersonas: 0 }
      }
      else {
        ObtenerSeccionAmparosDerivadoSiniestros.secCoberturas[i] = { ...ObtenerSeccionAmparosDerivadoSiniestros.secCoberturas[i], cobValorIngresado: "0.00", cobTasa: "0.00", cobPrima: "0.00" }
      }
    });







    this.setState({
      seccionIncendios: ObtenerSeccionIcendio,
      arrayValoresSeccionIncendios: ObtenerSeccionIcendio.secCoberturas,
      seccionRobo: ObtenerSeccionRobo,
      arrayValoresSeccionRobo: ObtenerSeccionRobo.secCoberturas,
      seccionAmparosBasicosDanios: ObtenerSeccionAmparosBasicosDanios,
      arrayValoresAmparosBasicosDanios: ObtenerSeccionAmparosBasicosDanios.secCoberturas,
      seccionAmparosBasicosDerivadoSiniestros: ObtenerSeccionAmparosDerivadosSiniestros,
      arrayValoresAmparosBasicosDerivadoSiniestros: ObtenerSeccionAmparosDerivadosSiniestros.secCoberturas,
      seccionAmparosOpcionales: ObtenerSeccionAmparosOpcionales,
      seccionAmparosDaniosPerdidas: ObtenerSeccionAmparosDaniosPerdidas,
      seccionAmparosDerivadoSiniestros: ObtenerSeccionAmparosDerivadoSiniestros,
      arrayValoresAmparosOpcionales: ObtenerSeccionAmparosOpcionales.secCoberturas,
      arrayValoresAmparosDaniosPerdidas: ObtenerSeccionAmparosDaniosPerdidas.secCoberturas,
      arrayValoresAmparosDerivadoSiniestros: ObtenerSeccionAmparosDerivadosSiniestros.secCoberturas,
    });

    let datosJSON = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      idCarrito: this.props.carrito.mongoCarrito
    }
    await this.props.datosFacturacion(datosJSON);
    if (this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "") {
      let param = undefined;
      if (parseInt(this.props.dataFacturacion.numItemsCarrito) > 1) {
        param = {
          pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
          totalItems: this.props.dataFacturacion.numItemsCarrito ? this.props.dataFacturacion.numItemsCarrito : "0",
          totalPrima: (this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal) ? this.props.dataFacturacion.carValoresTotales.primaTotal : "0.00",
          ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
        }
      }
      else {
        param = {
          pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
          totalItems: "1",
          totalPrima: "0.00",
          ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
        }
      }
      await this.props.actualizarTotalesCabecera(param);
    }

  }

  render() {
    let { seccionIncendios, arrayValoresSeccionIncendios,
      arrayErroresAmparosDaniosPerdidas,
      validate, formEditado, arrayErroresIncendio, seccionRobo, arrayValoresSeccionRobo, arrayErroresRobo, cargarTotalesRecuperado, habilitarBotonContinuar, arrayValoresAmparosBasicosDanios, seccionAmparosBasicosDanios, deducibleSelected, arrayDeducibles, riesgoSelected, seccionAmparosBasicosDerivadoSiniestros, arrayValoresAmparosBasicosDerivadoSiniestros, mostrarAmparosBasicosDanios, mostrarAmparosBasicosDerivadoSiniestros, seccionAmparosOpcionales, seccionAmparosDaniosPerdidas, seccionAmparosDerivadoSiniestros, arrayValoresAmparosOpcionales, arrayErroresAmparosOpcionales, arrayValoresAmparosDaniosPerdidas, arrayValoresAmparosDerivadoSiniestros, verNumeroPersonasAP, NumeroPersonasvalidador, descuentoIncendio, descuentoRobo } = this.state;

    console.log('arrayDeducibles', arrayDeducibles)
    return (
      <LoadingScreen
        loading={this.props.datosCarritoHogar.calculoPrimaHogarloading || this.props.datosCarritoHogar.generarPdfCotizacionHogarloading || this.props.datosCarritoHogar.planesHogarAdvanceLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >
        <Page title={this.state.datosHogar.titulo} breadcrumbs={[{ name: this.state.datosHogar.titulo, active: true }]}>
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step current"> {`1. Cotización`} </div>
                    <div className="step"> {`2. Resumen`} </div>
                    <div className="step"> {`3. Confirmación`} </div>
                    <div class="step"> {` 4. Forma de Pago `} </div>
                    <div class="step"> {` 5. Formulario de Vinculación `} </div>
                    <div class="step"> {` 6. Emisión `} </div>
                  </div>
                </div>
              </div>
              <Button className={"button-white"} onClick={this.onRegresar}>
                <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                REGRESAR
              </Button>
            </Col>
          </Row>
          <Row>
            <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box" >
              {seccionIncendios !== undefined && seccionIncendios.secCoberturas !== undefined &&
                <div>
                  {/** --------------Deducible Terremoto ---------------------------------------------------------*/}
                  {(!this.state.datosHogar.codigo || this.state.datosHogar.codigo == 'hogar-aig') &&

                    <Card className="flex-row">
                      <CardBody>
                        <h4 style={{ fontWeight: "bold" }}>Información del Riesgo</h4>
                        <p />
                        <Row >
                          <Col lg={4} md={12} sm={12} xs={12}>
                            <Row><Col><b>Deducible Terremoto Aplicado</b></Col></Row>
                            <Row><Col><b style={{ fontWeight: "normal", fontSize: '14px' }}>*Aplica únicamente para Protección Total</b></Col></Row> 
                          </Col>
                          <Col lg={4} md={12} sm={12} xs={12}>
                            <Select
                              id={"selectDeducibles"} // Optional.[String].Default: "". Input ID.
                              name={"selectDeducibles"} // Optional.[String].Default: "". Input name.
                              value={deducibleSelected} // Optional.[String].Default: "".
                              optionList={arrayDeducibles.sort((a, b) => a.value - b.value)} // Required.[Array of Object(s)].Default: [].
                              onChange={(deducibleSelected, e) => {
                                this.setState({ deducibleSelected, formEditado: true, habilitarBotonContinuar: false });
                              }} // Optional.[Func].Default: () => {}. Will return the value.
                              validate={validate}
                              validationCallback={res =>
                                this.setState({ validate: false })
                              }
                              classNameContainer="" //Optional.[String].Default: "".
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "Deducibles", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un deducible"
                              }}
                            />
                          </Col>
                        </Row>


                        {(!this.state.datosHogar.codigo || this.state.datosHogar.codigo != 'hogar-aig') &&
                          <Row >
                            <Col lg={4} md={12} sm={12} xs={12}>Riesgo Aplicado a la Cobertura de Robo</Col>
                            <Col lg={4} md={12} sm={12} xs={12}>
                              <Select
                                id={"selectRiesgos"} // Optional.[String].Default: "". Input ID.
                                name={"selectRiesgos"} // Optional.[String].Default: "". Input name.
                                value={riesgoSelected} // Optional.[String].Default: "".
                                optionList={arrayRiesgos} // Required.[Array of Object(s)].Default: [].
                                onChange={(riesgoSelected, e) => {
                                  this.setState({ riesgoSelected, formEditado: true, habilitarBotonContinuar: false });
                                }} // Optional.[Func].Default: () => {}. Will return the value.
                                validate={validate}
                                validationCallback={res =>
                                  this.setState({ validate: false })
                                }
                                classNameContainer="" //Optional.[String].Default: "".
                                onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                validationOption={{
                                  name: "Riesgo ", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                  check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                  required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                  msgOnError: "Por favor seleccione un riesgo"
                                }}
                              />
                            </Col>
                          </Row>

                        }


                        {this.state.datosHogar.codigo == 'hogar-aig' && true == false &&
                          <React.Fragment>

                            <Row >
                              <Col lg={4} md={12} sm={12} xs={12}>Descuento incendio</Col>
                              <Col lg={4} md={12} sm={12} xs={12}>
                                <Select
                                  id={"selectDescuentoIncendio"} // Optional.[String].Default: "". Input ID.
                                  name={"selectDescuentoIncendio"} // Optional.[String].Default: "". Input name.
                                  value={descuentoIncendio} // Optional.[String].Default: "".
                                  optionList={arrayDescuentos} // Required.[Array of Object(s)].Default: [].
                                  onChange={(descuentoIncendio, e) => {
                                    this.setState({ descuentoIncendio, formEditado: true, habilitarBotonContinuar: false });
                                  }} // Optional.[Func].Default: () => {}. Will return the value.
                                  validate={validate}
                                  validationCallback={res =>
                                    this.setState({ validate: false })
                                  }
                                  classNameContainer="" //Optional.[String].Default: "".
                                  onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                  customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                  validationOption={{
                                    name: "Descuento incendio ", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                    msgOnError: "Por favor seleccione un descuento"
                                  }}
                                />
                              </Col>
                            </Row>

                            <Row >
                              <Col lg={4} md={12} sm={12} xs={12}>Descuento robo</Col>
                              <Col lg={4} md={12} sm={12} xs={12}>
                                <Select
                                  id={"selectDescuentoRobo"} // Optional.[String].Default: "". Input ID.
                                  name={"selectDescuentoRobo"} // Optional.[String].Default: "". Input name.
                                  value={descuentoRobo} // Optional.[String].Default: "".
                                  optionList={arrayDescuentos} // Required.[Array of Object(s)].Default: [].
                                  onChange={(descuentoRobo, e) => {
                                    this.setState({ descuentoRobo, formEditado: true, habilitarBotonContinuar: false });
                                  }} // Optional.[Func].Default: () => {}. Will return the value.
                                  validate={validate}
                                  validationCallback={res =>
                                    this.setState({ validate: false })
                                  }
                                  classNameContainer="" //Optional.[String].Default: "".
                                  onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                  customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                  validationOption={{
                                    name: "Descuento robo ", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                    msgOnError: "Por favor seleccione un descuento"
                                  }}
                                />
                              </Col>
                            </Row>

                          </React.Fragment>


                        }
                      </CardBody>
                    </Card>

                  }


                  {(!this.state.datosHogar.codigo || this.state.datosHogar.codigo == 'hogar-aig') &&

                    <div>

                      {this.state.datosHogar.codigo == "hogar-aig" &&
                        <Row>
                          <Col style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                            <ButtonGroup style={{ marginBottom: 20, text: 'right' }}>
                              <Button
                                className={
                                  this.state.catAndNonCat
                                    ? "btn btn-primary "
                                    : "btn btn-primary btn-light"
                                }
                                onClick={(() => {
                                  this.setState({ catAndNonCat: true, formEditado: true })
                                })}
                                size='lg'
                                id='ProteccionTotalTooltip'
                              >
                                {'Protección total'}
                              </Button>
                              <UncontrolledTooltip
                                placement="bottom"
                                target="ProteccionTotalTooltip"
                              >
                                Cobertura Todo Riesgo (Incluye cobertura Catastrófica)
                              </UncontrolledTooltip>
                              <Button
                                className={
                                  !(this.state.catAndNonCat)
                                    ? "btn btn-primary "
                                    : "btn btn-primary btn-light"
                                }
                                onClick={(() => {
                                  this.setState({ catAndNonCat: false, formEditado: true })
                                })}
                                size='lg'
                                id='ProteccionEsencialTooltip'
                              >
                                {'Protección Esencial'}
                              </Button>
                              <UncontrolledTooltip
                                placement="bottom"
                                target="ProteccionEsencialTooltip"
                              >
                                Cobertura de Incendio y líneas aliadas, no incluye cobertura Catastrófica
                              </UncontrolledTooltip>
                            </ButtonGroup>
                          </Col>
                        </Row>

                      }
                      {/** --------------Seccion de Incendios ---------------------------------------------------------*/}
                      <Card className="flex-row">
                        <CardBody>
                          <h4 style={{ fontWeight: "bold" }}>{seccionIncendios.secNombre}</h4>
                          <p />
                          <Row>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label style={{ color: "#001871" }}>Valores Asegurados</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Porcentaje</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Prima</Label>
                            </Col>
                          </Row>
                          {arrayValoresSeccionIncendios.filter(valor => valor.cobVisible != false).map((seccion, i) => {

                            var arrayABuscar = []


                            var validarPadre = false
                            var mensajeValidacionPadre = ''
                            var valorPorsentaje = 0




                            let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                            let mensaje = "Debe ingresar un valor entre $0 y $" + valormaximo;

                            let tasa = seccion.cobTasaGratuita ? seccion.cobTasaGratuita : seccion.cobTasa;
                            let prima = seccion.cobPrima
                            if (this.state.datosHogar.codigo == 'hogar-aig') {
                              if (this.state.catAndNonCat) {
                                tasa = seccion.cobTasaCatAndNonCat
                                prima = seccion.cobPrimaCatAndNonCat
                              } else {
                                tasa = seccion.cobTasaNonCatProduct
                                prima = seccion.cobPrimaNonCatProduct
                              }
                            }
                            prima = prima ? parseFloat(prima).toFixed(2) : parseFloat(0).toFixed(2)
                            tasa = tasa ? parseFloat(tasa).toFixed(2) : parseFloat(0).toFixed(2)
                            if (valormaximo === 999999999999) {
                              mensaje = "Debe espeficicar un valor, en caso de no desear la cobertura ingresar cero.";
                            }

                            if (seccion.valArrayReferencias && seccion.valArrayReferencias.length > 0) {


                              seccion.valArrayReferencias.forEach(referencia => {

                                switch (referencia.valGrupoUbicacion) {
                                  case 'incendio':
                                    arrayABuscar = arrayValoresSeccionIncendios
                                    break;

                                  case 'robo':
                                    arrayABuscar = arrayValoresSeccionRobo
                                    break;

                                  default:
                                    arrayABuscar = []
                                    break;
                                }



                                const objetoABuscar = referencia.valCodigo
                                const porcentaje = referencia.valPorcentaje
                                var valorIngresadoPadre = 999999999999
                                var valorIngresado = parseFloat(seccion.cobValorIngresado)




                                const objetoValidador = arrayABuscar.find((valor) => valor.cobCodigo == objetoABuscar)


                                if (objetoValidador || valorIngresado > 0) {
                                  valorIngresadoPadre = parseFloat(objetoValidador.cobValorIngresado)
                                  valorIngresado = parseFloat(seccion.cobValorIngresado)
                                  valorPorsentaje = valorIngresadoPadre * porcentaje / 100
                                  valorPorsentaje = valorPorsentaje == 0 ? 0.01 : valorPorsentaje
                                  console.log(valorIngresado, valorPorsentaje, valormaximo, "VALIDACIONES");
                                  
                                  if (valorIngresado > valorPorsentaje) {
                                    validarPadre = true
                                    mensajeValidacionPadre = `Límite máximo hasta $${valorPorsentaje != 0.01 ? valorPorsentaje.toFixed(2) : 0.00.toFixed(2)} La cobertura de ${seccion.cobNombre} no puede ser mayor al ${porcentaje}% de la suma asegurada en ${objetoValidador.cobNombre}.`;

                                  }
                                  if(seccion.cobCodigo =='contenidos' && valorIngresadoPadre==0){
                                    validarPadre = false
                                    mensajeValidacionPadre = ``;

                                  }
                                }




                              });




                              //  console.log('seccionVer',seccion.cobCodigo, seccion.valArrayReferencias) 

                            }
                            return (
                              <Row key={i}>
                                <Col lg={3} md={3} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Textbox
                                    //tabIndex={i+1}
                                    type="text"
                                    id={seccion.cobCodigo}
                                    name={seccion.cobCodigo}
                                    disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                    classNameInput={"form-control"}
                                    placeholder="Ejemplo: (25000.52)"
                                    value={seccion.cobValorIngresado}
                                    validate={validate}
                                    onChange={(valor, e) => {


                                      if (seccion.cobCodigo == "contenidos") {

                                        if (isNaN(valor) || valor == '' || parseFloat(valor) <= 0) {


                                          var coberuraEncontrada = arrayValoresAmparosOpcionales.find(cob => cob.cobCodigo == 'mapp')

                                          var coberuraEncontradaIndex = arrayValoresAmparosOpcionales.findIndex(cob => cob.cobCodigo == coberuraEncontrada.cobCodigo)



                                          arrayValoresAmparosOpcionales[coberuraEncontradaIndex] = { ...arrayValoresAmparosOpcionales[coberuraEncontradaIndex], cobValorIngresado: 0, cobValorCambio: true }

                                        }



                                      }



                                      arrayValoresSeccionIncendios[i] = { ...arrayValoresSeccionIncendios[i], cobValorIngresado: valor, cobValorCambioRecalcular: true }


                                      this.setState({ arrayValoresSeccionIncendios, arrayValoresAmparosOpcionales, formEditado: true, habilitarBotonContinuar: false })




                                      if (arrayValoresSeccionIncendios[i].cobCodigo == "maquinaria"
                                        || arrayValoresSeccionIncendios[i].cobCodigo == "joyas"
                                        || arrayValoresSeccionIncendios[i].cobCodigo == "contenidos"
                                        || arrayValoresSeccionIncendios[i].cobCodigo == "obrasArte"
                                        || arrayValoresSeccionIncendios[i].cobCodigo == "objetosValor"
                                        || arrayValoresSeccionIncendios[i].cobCodigo == "contenidos"

                                      ) {
                                        const obj = arrayValoresSeccionRobo.filter(
                                          valor => valor.cobCodigo === arrayValoresSeccionIncendios[i].cobCodigo
                                        )
                                        const index = arrayValoresSeccionRobo.indexOf(obj[0])
                                        if (valor == 0 || valor == "") {

                                          arrayValoresSeccionRobo[index] = { ...arrayValoresSeccionRobo[index], cobValorIngresado: valor, cobValorCambioRecalcular: true }

                                          this.setState({ arrayValoresSeccionRobo, formEditado: true, habilitarBotonContinuar: false })
                                        }


                                      }

                                      if (arrayValoresSeccionIncendios[i].cobCodigo == "estructura" ||
                                        arrayValoresSeccionIncendios[i].cobCodigo == "contenidos") {

                                        const obj = arrayValoresAmparosOpcionales.filter(
                                          valor => valor.cobCodigo === "responsabilidadCivil"
                                        )

                                        const index_amparos = arrayValoresAmparosOpcionales.indexOf(obj[0])
                                        //valor estructura
                                        const valor_es = parseFloat(arrayValoresSeccionIncendios.find(
                                          valor => valor.cobCodigo === "estructura"
                                        ).cobValorIngresado) ? parseFloat(arrayValoresSeccionIncendios.find(
                                          valor => valor.cobCodigo === "estructura"
                                        ).cobValorIngresado) : 0
                                        //valor contenido
                                        const valor_co = parseFloat(arrayValoresSeccionIncendios.find(
                                          valor => valor.cobCodigo === "contenidos"
                                        ).cobValorIngresado) ? parseFloat(arrayValoresSeccionIncendios.find(
                                          valor => valor.cobCodigo === "contenidos"
                                        ).cobValorIngresado) : 0
                                        console.log('valor_es', valor_es)
                                        console.log('valor_co', valor_co)
                                        if (valor_es > 0 && valor_co > 0) {
                                          console.log('entro', arrayValoresAmparosOpcionales[index_amparos])
                                          arrayValoresAmparosOpcionales[index_amparos] = { ...arrayValoresAmparosOpcionales[index_amparos], cobValorIngresado: obj[0].cobValorIngresado > 2000 ? obj[0].cobValorIngresado : 2000, cobValorCambioRecalcular: true }

                                          this.setState({ arrayValoresAmparosOpcionales, formEditado: true, habilitarBotonContinuar: false })
                                        } else {
                                          arrayValoresAmparosOpcionales[index_amparos] = { ...arrayValoresAmparosOpcionales[index_amparos], cobValorIngresado: 0, cobValorCambioRecalcular: true }

                                          this.setState({ arrayValoresAmparosOpcionales, formEditado: true, habilitarBotonContinuar: false })
                                        }
                                      }



                                      if (arrayValoresSeccionIncendios[i].cobCodigo == "maquinaria"
                                        || arrayValoresSeccionIncendios[i].cobCodigo == "joyas"
                                        || arrayValoresSeccionIncendios[i].cobCodigo == "contenidos"
                                        || arrayValoresSeccionIncendios[i].cobCodigo == "obrasArte"
                                        || arrayValoresSeccionIncendios[i].cobCodigo == "objetosValor"
                                        || arrayValoresSeccionIncendios[i].cobCodigo == "contenidos"

                                      ) {

                                        var auxSuma = 0



                                        arrayValoresSeccionIncendios.forEach(element => {

                                          if (element.cobCodigo != "estructura") {


                                            auxSuma += parseFloat(element.cobValorIngresado)
                                          }

                                        });


                                        this.setState(

                                          {
                                            errorSumaIncendio: auxSuma > 250000
                                          }
                                        )



                                        console.log('arrayValoresSeccionIncendios', auxSuma)

                                      }


                                    }}
                                    onBlur={e => { }}
                                    validationCallback={res => {

                                      this.setState({ res })
                                    }}// Optional.[Func].Default: none. Return the validation result.
                                    validationOption={{
                                      name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                      check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                      required: true,
                                      type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                      min: 0, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                      max: validarPadre ? valorPorsentaje : parseFloat(valormaximo),
                                      msgOnError: validarPadre ? mensajeValidacionPadre : mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                    }}
                                  />
                                </Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Tasa</Col>
                                    <Col lg={12} md={12} sm={12} xs={12}><Label>{tasa} %</Label></Col>
                                  </Row>
                                </Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Prima</Col>
                                    <Col lg={12} md={12} sm={12} xs={12}><Label>$ {prima}</Label></Col>
                                  </Row>
                                </Col>
                                <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                  <hr></hr>
                                </Col>
                              </Row>
                            );
                          })}

                          {arrayErroresIncendio !== undefined &&
                            arrayErroresIncendio.length > 0 ?
                            <Alert color="warning">
                              <p>Por favor corregir la siguiente información para continuar:</p>
                              <ul >
                                {arrayErroresIncendio.map((error, i) => {
                                  return (
                                    <li >{error}</li>
                                  );

                                })}

                              </ul>
                            </Alert> : null
                          }

                        </CardBody>
                      </Card>



                      {/** --------------Seccion de Robo ---------------------------------------------- */}
                      <Card className="flex-row">
                        <CardBody>
                          <h4 style={{ fontWeight: "bold" }}>{seccionRobo.secNombre}</h4>
                          <p />
                          <Row>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label style={{ color: "#001871" }}>Valores Asegurados</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Porcentaje</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Prima</Label>
                            </Col>
                          </Row>
                          {arrayValoresSeccionRobo && arrayValoresSeccionRobo.filter(valor => valor.cobVisible != false).map((seccion, i) => {

                            console.log('seccionVer', seccion)



                            var arrayABuscar = []


                            var validarPadre = false
                            var mensajeValidacionPadre = ''
                            var valorPorsentaje = 0


                            if (seccion.valArrayReferencias && seccion.valArrayReferencias.length > 0) {


                              seccion.valArrayReferencias.forEach(referencia => {

                                switch (referencia.valGrupoUbicacion) {
                                  case 'incendio':
                                    arrayABuscar = arrayValoresSeccionIncendios
                                    break;

                                  case 'robo':
                                    arrayABuscar = arrayValoresSeccionRobo
                                    break;

                                  default:
                                    arrayABuscar = []
                                    break;
                                }

                                const objetoABuscar = referencia.valCodigo
                                const porcentaje = referencia.valPorcentaje
                                var valorIngresadoPadre = 999999999999
                                var valorIngresado = parseFloat(seccion.cobValorIngresado)


                                const objetoValidador = arrayABuscar.find((valor) => valor.cobCodigo == objetoABuscar)
                                // console.log('seccionVer', objetoValidador)

                                if (objetoValidador || valorIngresado > 0) {
                                  valorIngresadoPadre = parseFloat(objetoValidador.cobValorIngresado)
                                  valorIngresado = parseFloat(seccion.cobValorIngresado)
                                  valorPorsentaje = valorIngresadoPadre * porcentaje / 100
                                  valorPorsentaje = valorPorsentaje == 0 ? 0.01 : valorPorsentaje
                                  if (valorIngresado > valorPorsentaje) {
                                    validarPadre = true
                                    mensajeValidacionPadre = `Límite máximo hasta $${valorPorsentaje != 0.01 ? valorPorsentaje.toFixed(2) : 0.00.toFixed(2)} La cobertura de ${seccion.cobNombre} no puede ser mayor al ${porcentaje}% de la suma asegurada en ${objetoValidador.cobNombre}.`;
                                  }
                                }




                              });
                            }


                            let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                            let mensaje = "Debe ingresar un valor entre $0 y $" + valormaximo;
                            if (valormaximo === 999999999999) {
                              mensaje = "Debe espeficicar un valor, en caso de no desear la cobertura ingresar cero.";
                            }
                            return (
                              <Row key={i}>
                                <Col lg={3} md={3} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Textbox
                                    //tabIndex={i+1}
                                    type="text"
                                    id={seccion.cobCodigo}
                                    name={seccion.cobCodigo}
                                    disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                    classNameInput={"form-control"}
                                    placeholder="Ejemplo: (25000.52)"
                                    value={seccion.cobValorIngresado}
                                    validate={validate}
                                    onChange={(_valor, e) => {
                                      arrayValoresSeccionRobo[i] = { ...arrayValoresSeccionRobo[i], cobValorIngresado: _valor }
                                      console.log('arrayValoresSeccionRobo', arrayValoresSeccionRobo[i])
                                      if (arrayValoresSeccionRobo[i].cobCodigo == "maquinaria"
                                        || arrayValoresSeccionRobo[i].cobCodigo == "joyas"
                                        || arrayValoresSeccionRobo[i].cobCodigo == "obrasArte"
                                        || arrayValoresSeccionRobo[i].cobCodigo == "objetosValor"
                                        || arrayValoresSeccionRobo[i].cobCodigo == "contenidos"
                                      ) {
                                        const obj = arrayValoresSeccionIncendios.filter(
                                          x => x.cobCodigo === arrayValoresSeccionRobo[i].cobCodigo
                                        )

                                        let valor = obj[0].cobValorIngresado
                                        valor = valor ? parseFloat(valor) : 0
                                        console.log('valor.cobCodigo', obj[0].cobCodigo, valor)
                                        if (valor == 0 || valor == "") {

                                          arrayValoresSeccionRobo[i] = { ...arrayValoresSeccionRobo[i], cobValorIngresado: 0 }

                                        }
                                        if (arrayValoresSeccionRobo[i].cobCodigo == "contenidos") {
                                          let valor_float = _valor ? parseFloat(_valor) : 0

                                          if (valor_float == 0 || valor_float == "") {
                                            const responsabilidadCivil = arrayValoresAmparosOpcionales.filter(
                                              x => x.cobCodigo === "responsabilidadCivil"
                                            )
                                            const index = arrayValoresAmparosOpcionales.indexOf(responsabilidadCivil[0])
                                            arrayValoresAmparosOpcionales[index] = { ...arrayValoresAmparosOpcionales[index], cobValorIngresado: 0 }
                                            this.setState({ arrayValoresAmparosOpcionales, formEditado: true, habilitarBotonContinuar: false })
                                          }
                                        }

                                      }
                                      this.setState({ arrayValoresSeccionRobo, formEditado: true, habilitarBotonContinuar: false })
                                    }}
                                    onBlur={e => { }}
                                    validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                    validationOption={{
                                      name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                      check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                      required: true,
                                      type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                      min: 0, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                      max: validarPadre ? valorPorsentaje : parseFloat(valormaximo),
                                      msgOnError: validarPadre ? mensajeValidacionPadre : mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                    }}
                                  />
                                </Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Tasa</Col>
                                    <Col lg={12} md={12} sm={12} xs={12}><Label>{parseFloat(seccion.cobTasa).toFixed(2)} %</Label></Col>
                                  </Row>
                                </Col>
                                <Col lg={3} md={3} sm={12} xs={12}>
                                  <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Prima</Col>
                                    <Col lg={12} md={12} sm={12} xs={12}><Label>$ {parseFloat(seccion.cobPrima).toFixed(2)}</Label></Col>
                                  </Row>
                                </Col>
                                <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                  <hr></hr>
                                </Col>
                              </Row>
                            );
                          })}

                          {arrayErroresRobo !== undefined &&
                            arrayErroresRobo.length > 0
                            ?
                            <Alert color="warning">
                              <p>Por favor corregir la siguiente información para continuar:</p>
                              <ul >
                                {arrayErroresRobo.map((error, i) => {
                                  return (
                                    <li key={i}>{error}</li>
                                  );

                                })}

                              </ul>
                            </Alert> : null
                          }

                        </CardBody>
                      </Card>



                      {/** --------------Seccion de AMparo Basico de Daños Perdidas---------------------------------------------- */}

                      {arrayValoresAmparosBasicosDanios && arrayValoresAmparosBasicosDanios !== undefined && mostrarAmparosBasicosDanios &&

                        <Card className="flex-row">

                          <CardBody>
                            <h4 style={{ fontWeight: "bold" }}>{seccionAmparosBasicosDanios.secNombre ? seccionAmparosBasicosDanios.secNombre : ""}</h4>
                            <p />
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label>% Limite Asegurado</Label>
                              </Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label style={{ color: "#001871" }}>Valor Asegurado</Label>
                              </Col>
                            </Row>
                            {arrayValoresAmparosBasicosDanios.filter(valor => valor.cobVisible != false).map((seccion, i) => {

                              console.log('arrayValoresAmparosBasicosDanios', seccion)
                              let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                              let valorMinimo = seccion.cobValorIngresadoMinimo ? seccion.cobValorIngresadoMinimo : 0;
                              let mensaje = "Debe ingresar un valor entre $" + valorMinimo + " y $" + valormaximo;
                              if (valormaximo === 999999999999) {
                                mensaje = "Se otorga una gratuidad de esta cobertura hasta un valor de $" + valorMinimo;
                              }
                              return (
                                <Row key={i}>
                                  <Col lg={6} md={6} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>% Limite Asegurado</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>{(seccion.cobTasa)} %</Label></Col>
                                    </Row>
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Textbox
                                      //tabIndex={i+1}
                                      type="text"
                                      id={seccion.cobCodigo}
                                      name={seccion.cobCodigo}
                                      disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                      classNameInput={"form-control"}
                                      placeholder="Ejemplo: (25000.52)"
                                      value={seccion.cobValorIngresado}
                                      validate={validate}
                                      onChange={(valor, e) => {
                                        arrayValoresAmparosBasicosDanios[i] = { ...arrayValoresAmparosBasicosDanios[i], cobValorIngresado: valor, cobValorCambio: true }
                                        this.setState({ arrayValoresAmparosBasicosDanios, formEditado: true, habilitarBotonContinuar: false })
                                      }}
                                      onBlur={e => { }}
                                      validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                      validationOption={{
                                        name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true,
                                        type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                        min: parseFloat(valorMinimo), // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                        max: parseFloat(valormaximo),
                                        msgOnError: mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                      }}
                                    />
                                  </Col>
                                  <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                    <hr></hr>
                                  </Col>
                                </Row>
                              );
                            })}

                          </CardBody>
                        </Card>


                      }



                      {/** --------------Seccion de Amparo Gastos Adicionales Derivados de Siniestros ---------------------------------------------- */}

                      {arrayValoresAmparosBasicosDerivadoSiniestros && arrayValoresAmparosBasicosDerivadoSiniestros !== undefined && mostrarAmparosBasicosDerivadoSiniestros &&

                        <Card className="flex-row">
                          <CardBody>
                            <h4 style={{ fontWeight: "bold" }}>{seccionAmparosBasicosDerivadoSiniestros.secNombre ? seccionAmparosBasicosDerivadoSiniestros.secNombre : ""}</h4>
                            <p />
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label>% Limite Asegurado</Label>
                              </Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label style={{ color: "#001871" }}>Valor Asegurado</Label>
                              </Col>
                            </Row>
                            {arrayValoresAmparosBasicosDerivadoSiniestros.filter(valor => valor.cobVisible != false).map((seccion, i) => {
                              let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                              let valorMinimo = seccion.cobValorIngresadoMinimo ? seccion.cobValorIngresadoMinimo : 0;
                              let mensaje = "Debe ingresar un valor entre $" + valorMinimo + " y $" + valormaximo;
                              if (valormaximo === 999999999999) {
                                mensaje = "Se otorga una gratuidad de esta cobertura hasta un valor de $" + valorMinimo;
                              }
                              return (
                                <Row key={i}>
                                  <Col lg={6} md={6} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>% Limite Asegurado</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>{(seccion.cobTasa)} %</Label></Col>
                                    </Row>
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Textbox
                                      //tabIndex={i+1}
                                      type="text"
                                      id={seccion.cobCodigo}
                                      name={seccion.cobCodigo}
                                      disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                      classNameInput={"form-control"}
                                      placeholder="Ejemplo: (25000.52)"
                                      value={seccion.cobValorIngresado}
                                      validate={validate}
                                      onChange={(valor, e) => {
                                        arrayValoresAmparosBasicosDerivadoSiniestros[i] = { ...arrayValoresAmparosBasicosDerivadoSiniestros[i], cobValorIngresado: valor, cobValorCambio: true }
                                        this.setState({ arrayValoresAmparosBasicosDerivadoSiniestros, formEditado: true, habilitarBotonContinuar: false })
                                      }}
                                      onBlur={e => { }}
                                      validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                      validationOption={{
                                        name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true,
                                        type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                        min: parseFloat(valorMinimo), // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                        max: parseFloat(valormaximo),
                                        msgOnError: mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                      }}
                                    />
                                  </Col>
                                  <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                    <hr></hr>
                                  </Col>
                                </Row>
                              );
                            })}

                          </CardBody>
                        </Card>


                      }




                      {/** --------------Seccion de Amparos Opcionales ---------------------------------------------- */}
                      <Card className="flex-row">
                        <CardBody>
                          <h4 style={{ fontWeight: "bold" }}>{seccionAmparosOpcionales.secNombre}</h4>
                          <p />
                          <Row>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label style={{ color: "#001871" }}>Valores Asegurados</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Porcentaje</Label>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                              <Label>Prima</Label>
                            </Col>
                          </Row>
                          {arrayValoresAmparosOpcionales && arrayValoresAmparosOpcionales.filter(valor => (valor.cobVisible != false && valor.cobCodigo)).map((seccion, i) => {

                            console.log("SECCION22222", arrayValoresAmparosOpcionales, seccion)


                            var arrayABuscar = []

                            var validarPadre = false
                            var mensajeValidacionPadre = ''
                            var valorPorsentaje = 0

                            if (seccion.valArrayReferencias && seccion.valArrayReferencias.length > 0) {


                              seccion.valArrayReferencias.forEach(referencia => {

                                switch (referencia.valGrupoUbicacion) {
                                  case 'incendio':
                                    arrayABuscar = arrayValoresSeccionIncendios
                                    break;

                                  case 'robo':
                                    arrayABuscar = arrayValoresSeccionRobo
                                    break;

                                  default:
                                    arrayABuscar = []
                                    break;
                                }



                                const objetoABuscar = referencia.valCodigo
                                const porcentaje = referencia.valPorcentaje
                                var valorIngresadoPadre = 999999999999
                                var valorIngresado = parseFloat(seccion.cobValorIngresado)


                                const objetoValidador = arrayABuscar.find((valor) => valor.cobCodigo == objetoABuscar)
                                // console.log('seccionVer', objetoValidador)

                                if (objetoValidador || valorIngresado > 0) {
                                  valorIngresadoPadre = parseFloat(objetoValidador.cobValorIngresado)
                                  valorIngresado = parseFloat(seccion.cobValorIngresado)
                                  valorPorsentaje = valorIngresadoPadre * porcentaje / 100
                                  valorPorsentaje = valorPorsentaje == 0 ? 0.01 : valorPorsentaje

                                  if (valorIngresado > valorPorsentaje) {

                                    validarPadre = true

                                    mensajeValidacionPadre = `Límite máximo hasta $${valorPorsentaje != 0.01 ? valorPorsentaje.toFixed(2) : 0.00.toFixed(2)} La cobertura de ${seccion.cobNombre} no puede ser mayor al ${porcentaje}% de la suma asegurada en ${objetoValidador.cobNombre}.`;
                                  }
                                }




                              });




                              //  console.log('seccionVer',seccion.cobCodigo, seccion.valArrayReferencias) 

                            }

                            let disabled = false
                            if (seccion.cobCodigo == "eGuardOpcional") {
                              var coberuraEncontrada = arrayValoresAmparosOpcionales.find(cob => cob.cobCodigo == 'equiposElectricosElectronicos')
                              if (isNaN(coberuraEncontrada.cobValorIngresado) || coberuraEncontrada.cobValorIngresado <= 0) {
                                disabled = true
                              }

                            }

                            if (seccion.cobCodigo == "mapp") {
                              var coberuraEncontrada = arrayValoresSeccionIncendios.find(cob => cob.cobCodigo == 'contenidos')
                              if (isNaN(coberuraEncontrada.cobValorIngresado) || coberuraEncontrada.cobValorIngresado == '' || coberuraEncontrada.cobValorIngresado <= 0) {
                                disabled = true
                              }

                            }



                            if (seccion.cobNombre == 'Rotura de Maquinaria') {
                              console.log('valorIngresado2222', valorPorsentaje, validarPadre ? valorPorsentaje < 1 ? -1 : parseInt(valorPorsentaje) : parseFloat(valormaximo))
                            }



                            let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                            let mensaje = "Debe ingresar un valor entre $0 y $" + valormaximo;
                            if (seccion.cobCodigo == "personalDomestico") {
                              mensaje = "Debe ingresar un valor entre 0 y " + valormaximo;
                            }

                            if (valormaximo === 999999999999) {
                                mensaje = "Debe espeficicar un valor, en caso de no desear la cobertura ingresar cero.";
                            }

                            if (seccion.cobCodigo == "llaveProtegida" || seccion.cobCodigo == "documentosProtegidos") {
                              if (seccion.cobValorIngresado == "") {
                                seccion.cobValorIngresado = 0
                              }
                            }


                            return (
                              <div>
                                <Row key={i}>
                                  <Col lg={3} md={3} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    {seccion.cobCodigo === "eGuardOpcional" ||
                                      seccion.cobCodigo === "mapp" ||
                                      seccion.cobCodigo === "personalDomestico"

                                      ?

                                      <Select
                                        id="select"
                                        name="select"
                                        placeholder="Seleccione"
                                        disabled={disabled}
                                        optionList={
                                          seccion.cobCodigo === "mapp" ?
                                            [
                                              {
                                                id: 0,
                                                name: "0"
                                              }, {
                                                id: 250,
                                                name: "250"
                                              }
                                            ] :
                                            seccion.cobCodigo === "personalDomestico" ?

                                              Array.from({ length: 6 }).map((v, i) => (
                                                {
                                                  id: i,
                                                  name: i
                                                }
                                              ))
                                              :
                                              [
                                                {
                                                  id: 0,
                                                  name: "0"
                                                }, {
                                                  id: 1000,
                                                  name: "1000"
                                                }
                                              ]
                                        }
                                        value={seccion.cobValorIngresado}
                                        onChange={(valor) => {




                                          var coberuraEncontrada = arrayValoresAmparosOpcionales.find(cob => cob.cobCodigo == seccion.cobCodigo)
                                          console.log('hola ver como esta', coberuraEncontrada)
                                          arrayValoresAmparosOpcionales[i] = { ...arrayValoresAmparosOpcionales[i], cobValorIngresado: valor, cobValorCambio: true }
                                          this.setState({ arrayValoresAmparosOpcionales, formEditado: true, habilitarBotonContinuar: false })
                                        }}
                                      />
                                      : <Textbox
                                        //tabIndex={i+1}
                                        type="text"
                                        id={seccion.cobCodigo}
                                        name={seccion.cobCodigo}
                                        disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                        classNameInput={"form-control"}
                                        placeholder="Ejemplo: (25000.52)"
                                        value={seccion.cobValorIngresado}
                                        validate={validate}
                                        onChange={(valor, e) => {



                                          // eGuardOpcional equiposElectricosElectronicos
                                          if (seccion.cobCodigo == "equiposElectricosElectronicos") {

                                            if (isNaN(valor) || valor == '' || parseFloat(valor) <= 0) {


                                              var coberuraEncontrada = arrayValoresAmparosOpcionales.find(cob => cob.cobCodigo == 'eGuardOpcional')

                                              var coberuraEncontradaIndex = arrayValoresAmparosOpcionales.findIndex(cob => cob.cobCodigo == coberuraEncontrada.cobCodigo)



                                              arrayValoresAmparosOpcionales[coberuraEncontradaIndex] = { ...arrayValoresAmparosOpcionales[coberuraEncontradaIndex], cobValorIngresado: 0, cobValorCambio: true }
                                              console.log('rrayValoresAmparosOpcionales[coberuraEncontradaIndex]', arrayValoresAmparosOpcionales[coberuraEncontradaIndex])
                                            }



                                          }


                                          arrayValoresAmparosOpcionales[i] = { ...arrayValoresAmparosOpcionales[i], cobValorIngresado: valor, cobValorCambio: true }
                                          if (seccion.cobCodigo === "personalDomestico") {
                                            if (parseFloat(valor) > 0) {
                                              this.setState({ verNumeroPersonasAP: true })
                                            }
                                            else {
                                              this.setState({ verNumeroPersonasAP: false })
                                            }
                                            this.setState({ arrayValoresAmparosOpcionales, formEditado: true, NumeroPersonasvalidador: valor })


                                          }
                                          if (seccion.cobCodigo === "responsabilidadCivil") {
                                            const obj = arrayValoresSeccionIncendios.filter(
                                              valor =>
                                                valor.cobCodigo === "estructura"
                                              //                       || valor.cobCodigo === "contenidos"
                                            )

                                            let ingresar = true;

                                            obj.forEach(element => {
                                              let valor = element.cobValorIngresado ? parseFloat(element.cobValorIngresado) : 0
                                              if (valor == 0 || valor == "") {
                                                ingresar = false
                                              }
                                            });



                                            if (!ingresar) {

                                              arrayValoresAmparosOpcionales[i] = { ...arrayValoresAmparosOpcionales[i], cobValorIngresado: 0 }
                                            } else {
                                              if (parseFloat(valor) > 0) {
                                                arrayValoresAmparosOpcionales[i] = { ...arrayValoresAmparosOpcionales[i], cobValorIngresado: valor }
                                              } else {
                                                arrayValoresAmparosOpcionales[i] = { ...arrayValoresAmparosOpcionales[i], cobValorIngresado: 2000 }

                                              }
                                            }
                                          }
                                          this.setState({ arrayValoresAmparosOpcionales, formEditado: true, habilitarBotonContinuar: false })

                                        }}
                                        onBlur={e => { }}
                                        validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                        validationOption={{
                                          name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                          required: true,
                                          type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                          min: 0, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                          max: validarPadre ? valorPorsentaje < 1 ? -1 : parseInt(valorPorsentaje) : parseFloat(valormaximo),
                                          msgOnError: validarPadre ? mensajeValidacionPadre : mensaje
                                        }}
                                      />}
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    {
                                      seccion.cobCodigo === "eGuardOpcional" || seccion.cobCodigo === "personalDomestico"
                                        || seccion.cobCodigo == "llaveProtegida" || seccion.cobCodigo == "documentosProtegidos"
                                        ? null :
                                        <Row>
                                          <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Tasa</Col>
                                          <Col lg={12} md={12} sm={12} xs={12}><Label>{seccion.cobTasa} %</Label></Col>
                                        </Row>
                                    }
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Prima</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>$ {parseFloat(seccion.cobPrima).toFixed(2)}</Label></Col>
                                    </Row>


                                  </Col>
                                  <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                    <hr></hr>
                                  </Col>
                                </Row>
                                {/*seccion.cobCodigo && seccion.cobCodigo === "personalDomestico" && verNumeroPersonasAP &&
                                  
                                  <Row key={i + 999} style={{display:'none'}}>
                                    <Col lg={3} md={3} sm={12} xs={12}>{seccion.labelIngresoPersonas ? seccion.labelIngresoPersonas : 'Ingresar Nro de Personas(Menores a 65 años)'}</Col>
                                    <Col lg={3} md={3} sm={12} xs={12}>
                                      <Textbox
                                        //tabIndex={i+1}                                                  
                                        type="text"
                                        id={"numeroPersonasAP"}
                                        name={"numeroPersonasAP"}
                                        disabled={false} // Optional.[Bool].Default: false.
                                        classNameInput={"form-control"}
                                        placeholder="Ejemplo : 4"
                                        value={seccion.cobNumeroPersonas}
                                        validate={validate}
                                        onChange={(valor, e) => {
                                          arrayValoresAmparosOpcionales[i] = { ...arrayValoresAmparosOpcionales[i], cobNumeroPersonas: valor }
                                          this.setState({ arrayValoresAmparosOpcionales, formEditado: true, NumeroPersonasvalidador: valor })
                                        }}
                                        onBlur={e => { }}
                                        validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                        validationOption={{
                                          name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                          required: true,
                                          type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                          min: 1, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                          max: parseInt(seccion.cobValorMaximoNumeroPersonas),
                                          msgOnError: 'Debe ingresar el número de personas entre 1 y ' + seccion.cobValorMaximoNumeroPersonas // Optional.[Bool].Default: true. To determin if it is a required field.
                                        }}
                                      />
                                    </Col>
                                    <Col lg={3} md={3} sm={12} xs={12}></Col><Col lg={3} md={3} sm={12} xs={12}></Col>
                                    <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                      <hr></hr>
                                    </Col>
                                  </Row>
                                */}

                              </div>
                            );
                          })}

                          {console.log('seccionver2222', (arrayErroresAmparosOpcionales !== undefined &&
                            arrayErroresAmparosOpcionales.length &&
                            arrayErroresAmparosOpcionales.length > 0
                          ))}



                          {(arrayErroresAmparosOpcionales !== undefined &&
                            arrayErroresAmparosOpcionales.length &&
                            arrayErroresAmparosOpcionales.length > 0
                          ) === true

                            &&
                            <Alert color="warning">
                              <p>Por favor corregir la siguiente información para continuar:</p>
                              <ul >
                                {arrayErroresAmparosOpcionales.map((error, i) => {
                                  return (
                                    <li key={i}>{error}</li>
                                  );

                                })}

                              </ul>
                            </Alert>
                          }


                        </CardBody>
                      </Card>

                      {/** --------------Seccion de Amparos Danios y perdidas aquiii ---------------------------------------------- */}

                      {(this.state.datosHogar.codigo == 'hogar-aig' && this.props.datosCarritoHogar.setCarritoHogar.valorTotal && !this.props.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima) &&
                        <Card className="flex-row">
                          <CardBody>


                            <h4 style={{ fontWeight: "bold" }}>{seccionAmparosDaniosPerdidas.secNombre}</h4>
                            <p />
                            <Row>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label style={{ color: "#001871" }}>Valores Asegurados</Label>
                              </Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label>Porcentaje</Label>
                              </Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label>Prima</Label>
                              </Col>
                            </Row>
                            {arrayValoresAmparosDaniosPerdidas && arrayValoresAmparosDaniosPerdidas.filter(valor => valor.cobVisible != false).map((seccion, i) => {

                              console.log('seccionAMparo', seccion)

                              let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                              let mensaje = "Debe ingresar un valor entre $0 y $" + valormaximo;

                              let tasa = seccion.cobTasa;
                              let prima = seccion.cobPrima
                              /*  if (this.state.datosHogar.codigo == 'hogar-aig') {
                                 if (this.state.catAndNonCat) {
                                   tasa = seccion.cobTasaCatAndNonCat
                                   prima = seccion.cobPrimaCatAndNonCat
                                 } else {
                                   tasa = seccion.cobTasaNonCatProduct
                                   prima = seccion.cobPrimaNonCatProduct
                                 }
                               } */
                              prima = prima ? parseFloat(prima).toFixed(2) : parseFloat(0).toFixed(2)
                              tasa = tasa ? parseFloat(tasa).toFixed(2) : parseFloat(0).toFixed(2)
                              if (valormaximo === 999999999999) {
                                mensaje = "Debe espeficicar un valor, en caso de no desear la cobertura ingresar cero.";
                              }
                              return (
                                <Row key={i}>
                                  <Col lg={3} md={3} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Textbox
                                      //tabIndex={i+1}
                                      type="text"
                                      id={seccion.cobCodigo}
                                      name={seccion.cobCodigo}
                                      disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                      classNameInput={"form-control"}
                                      placeholder="Ejemplo: (25000.52)"
                                      value={seccion.cobValorIngresado}
                                      validate={validate}
                                      onChange={(valor, e) => {

                                        const arraycop = arrayValoresAmparosDaniosPerdidas
                                        const coberturaEncontrada = arraycop.find(cob => cob.cobCodigo == seccion.cobCodigo)
                                        const indiceCobertura = arraycop.findIndex(cob => cob.cobCodigo == coberturaEncontrada.cobCodigo)
                                        arraycop[indiceCobertura] = { ...arraycop[indiceCobertura], cobValorIngresado: valor, cobValorCambioRecalcular: true }
                                        this.setState({ arrayValoresAmparosDaniosPerdidas: arraycop, formEditado: true, habilitarBotonContinuar: false })
                                      }}
                                      onBlur={e => { }}
                                      validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                      validationOption={{
                                        name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true,
                                        type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                        min: 0, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                        max: parseFloat(valormaximo),
                                        msgOnError: mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                      }}
                                    />
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Tasa</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>{parseFloat(tasa).toFixed(2)} %</Label></Col>
                                    </Row>
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Prima</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>$ {parseFloat(prima).toFixed(2)}</Label></Col>
                                    </Row>
                                  </Col>
                                  <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                    <hr></hr>
                                  </Col>
                                </Row>
                              );
                            })}

                            {arrayErroresAmparosDaniosPerdidas !== undefined &&
                              arrayErroresAmparosDaniosPerdidas.length > 0 ?
                              <Alert color="warning">
                                <p>Por favor corregir la siguiente información para continuar:</p>
                                <ul >
                                  {arrayErroresAmparosDaniosPerdidas.map((error, i) => {
                                    return (
                                      <li key={i}>{error}</li>
                                    );

                                  })}

                                </ul>
                              </Alert> : null
                            }

                          </CardBody>
                        </Card>
                      }




                      {/** --------------Seccion de Amparos Derivados ---------------------------------------------- */}
                      {(this.state.datosHogar.codigo == 'hogar-aig' && this.props.datosCarritoHogar.setCarritoHogar.valorTotal && !this.props.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima) &&
                        <Card className="flex-row">
                          <CardBody>
                            <h4 style={{ fontWeight: "bold" }}>{seccionAmparosDerivadoSiniestros.secNombre}</h4>
                            <p />
                            <Row>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}></Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label style={{ color: "#001871" }}>Valores Asegurados</Label>
                              </Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label>Porcentaje</Label>
                              </Col>
                              <Col lg={3} md={3} sm={6} xs={12} className={"d-none d-sm-none d-md-block d-lg-block d-xl-block"}>
                                <Label>Prima</Label>
                              </Col>
                            </Row>
                            {arrayValoresAmparosBasicosDerivadoSiniestros && arrayValoresAmparosBasicosDerivadoSiniestros.filter(valor => valor.cobVisible != false).map((seccion, i) => {
                              let valormaximo = seccion.cobValorMaximo ? seccion.cobValorMaximo : 999999999999;
                              let mensaje = "Debe ingresar un valor entre $0 y $" + valormaximo;

                              let tasa = seccion.cobTasa;
                              let prima = seccion.cobPrima
                              /*  if (this.state.datosHogar.codigo == 'hogar-aig') {
                                 if (this.state.catAndNonCat) {
                                   tasa = seccion.cobTasaCatAndNonCat
                                   prima = seccion.cobPrimaCatAndNonCat
                                 } else {
                                   tasa = seccion.cobTasaNonCatProduct
                                   prima = seccion.cobPrimaNonCatProduct
                                 }
                               } */
                              prima = prima ? parseFloat(prima).toFixed(2) : parseFloat(0).toFixed(2)
                              tasa = tasa ? parseFloat(tasa).toFixed(2) : parseFloat(0).toFixed(2)
                              if (valormaximo === 999999999999) {
                                mensaje = "Debe espeficicar un valor, en caso de no desear la cobertura ingresar cero.";
                              }
                              return (
                                <Row key={i}>
                                  <Col lg={3} md={3} sm={12} xs={12}>{seccion.cobNombre}</Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Textbox
                                      //tabIndex={i+1}
                                      type="text"
                                      id={seccion.cobCodigo}
                                      name={seccion.cobCodigo}
                                      disabled={!seccion.cobEditable} // Optional.[Bool].Default: false.
                                      classNameInput={"form-control"}
                                      placeholder="Ejemplo: (25000.52)"
                                      value={seccion.cobValorIngresado}
                                      validate={validate}
                                      onChange={(valor, e) => {
                                        arrayValoresAmparosBasicosDerivadoSiniestros[i] = { ...arrayValoresAmparosBasicosDerivadoSiniestros[i], cobValorIngresado: valor, cobValorCambioRecalcular: true }
                                        this.setState({ arrayValoresAmparosBasicosDerivadoSiniestros, formEditado: true, habilitarBotonContinuar: false })
                                      }}
                                      onBlur={e => { }}
                                      validationCallback={res => this.setState({ res })}// Optional.[Func].Default: none. Return the validation result.
                                      validationOption={{
                                        name: seccion.cobNombre, // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        required: true,
                                        type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                        min: 0, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                        max: parseFloat(valormaximo),
                                        msgOnError: mensaje // Optional.[Bool].Default: true. To determin if it is a required field.
                                      }}
                                    />
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Tasa</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>{parseFloat(tasa).toFixed(2)} %</Label></Col>
                                    </Row>
                                  </Col>
                                  <Col lg={3} md={3} sm={12} xs={12}>
                                    <Row>
                                      <Col lg={12} md={12} sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>Prima</Col>
                                      <Col lg={12} md={12} sm={12} xs={12}><Label>$ {parseFloat(prima).toFixed(2)}</Label></Col>
                                    </Row>
                                  </Col>
                                  <Col sm={12} xs={12} className={"d-block d-sm-block d-md-none d-lg-none d-xl-none"}>
                                    <hr></hr>
                                  </Col>
                                </Row>
                              );
                            })}



                          </CardBody>
                        </Card>
                      }

                    </div>


                  }

                  {
                    this.state.datosHogar.codigo == 'advance' &&
                    <div>
                      {this.props.datosCarritoHogar.setPlanesHogarAdvance && this.props.datosCarritoHogar.setPlanesHogarAdvance.planesContenido != null && (

                        <Row>
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <Card className="flex-row">
                              <CardBody >
                                <h4 style={{ fontWeight: "bold" }}>Plan de contenidos</h4>
                                <p />

                                <div style={{ height: '800px' }}>
                                  <div style={{ position: 'absolute', top: 50, right: 0, bottom: 0, left: 0 }}>
                                    <Planes
                                      planSeleccionado={this.state.planContenidosSeleccionado}
                                      height={'60px'}
                                      planes={this.props.datosCarritoHogar.setPlanesHogarAdvance.planesContenido}
                                      onChangePlan={plan => {

                                        console.log(plan)
                                        this.setState({
                                          formEditado: true,
                                          planContenidosSeleccionado: plan.codigoProducto == this.state.planContenidosSeleccionado ? null : plan.codigoProducto,
                                        })

                                        setTimeout(() => {
                                          this.onValidateform()
                                        }, 300);
                                      }
                                      }
                                    />

                                  </div>
                                </div>




                              </CardBody>
                            </Card>
                          </Col>
                        </Row>



                      )}








                      {this.props.datosCarritoHogar.setPlanesHogarAdvance && this.props.datosCarritoHogar.setPlanesHogarAdvance.planesEstructura != null && (
                        <Row>
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <Card className="flex-row">
                              <CardBody >
                                <h4 style={{ fontWeight: "bold" }}>Plan de estructura</h4>
                                <p />

                                <div style={{ height: '1300px' }}>
                                  <div style={{ position: 'absolute', top: 50, right: 0, bottom: 0, left: 0 }}>
                                    <Planes
                                      planSeleccionado={this.state.planEstructuraSeleccionado}
                                      height={'120px'}
                                      planes={this.props.datosCarritoHogar.setPlanesHogarAdvance.planesEstructura}
                                      onChangePlan={plan => {
                                        this.setState({
                                          formEditado: true,
                                          planEstructuraSeleccionado: plan.codigoProducto == this.state.planEstructuraSeleccionado ? null : plan.codigoProducto,
                                        })

                                        setTimeout(() => {
                                          this.onValidateform()
                                        }, 300);
                                      }
                                      }
                                    />

                                  </div>
                                </div>




                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      )}




                    </div>

                  }







                </div>
              }

            </Col>

            <Col lg={4} md={12} className="detalle-impuestos-box" >

              <ValoresCotizacionHogar errorSumaIncendio={this.state.errorSumaIncendio} formEditado={formEditado} paso={"valores-cotizacion"} metodo={this.onValidateform} cargarTotalesRecuperado={cargarTotalesRecuperado} codigoProducto={this.state.datosHogar.codigo} habilitarBotonContinuar={(this.state.datosHogar.codigo != 'advance') ? habilitarBotonContinuar : (this.state.planContenidosSeleccionado != null || this.state.planEstructuraSeleccionado != null) ? false : true} />
            </Col>
          </Row>
        </Page>
      </LoadingScreen>
    );
  }
};

const mapStateToProps = state => ({
  seccionesCoberturasHogar: state.datosCarritoHogar.setSeccionesCoberturasHogar,
  carrito: state.datosCarritoHogar.setCarritoHogar,
  datosCarritoHogar: state.datosCarritoHogar,
  catalogosHogar: state.catalogosHogar,
  dataFacturacion: state.dataFacturacion.datosFacturacion
});

const mapDispatchToProps = dispatch => {
  return {
    caluloPrima: (param) => dispatch(FetchCalculoPrimaHogar(param)),
    listarCarritoHogar: (param) => dispatch(FetchListarCarritoHogar(param)),
    setProductoActual: (param) => dispatch(setProductoActualCotizadoHogar(param)),
    guardarGenerarPdfCotizacion: (param) => dispatch(FetchGenerarEnviarPdfHogar(param)),
    actualizarTotalesCabecera: (param) => dispatch(FetchTotalesCabeceraCotizadores(param)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    cargarCoberturasHogarAdvance: () => dispatch(FetchDataCoberturasHogarAdvance()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionValoresPaso4HogarAig)
);
